/* unplugin-vue-components disabled */import script from "./ManageAside.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageAside.vue?vue&type=script&setup=true&lang=js"

import "./ManageAside.vue?vue&type=style&index=0&id=5fd1b580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd1b580"]])

export default __exports__